import { ThunkDispatch } from 'redux-thunk'
import { connect } from 'react-redux'
import { AnyAction } from 'redux'

import { IStateProps } from '../types'
import { IDisplayDispatchProps } from './types'
import { fetchPlans, deletePlan } from '../../../../store/plans/actions'
import { IState } from '../../../../store/types'
import { IPlan } from '../../../../types/plan'
import { Display } from './Display'

const mapStateToProps = (state: IState): IStateProps => {
  return {
    plans: state.plans,
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>): IDisplayDispatchProps => {
  return {
    fetchPlans: () => {
      return dispatch(fetchPlans())
    },
    deletePlan: (plan: IPlan) => {
      return dispatch(deletePlan(plan))
    }
  }
}

const DisplayContainer = connect(mapStateToProps, mapDispatchToProps)(Display)

export {
  DisplayContainer
}
